import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'ncoded-component-library';
import { useForm, useFormState } from 'react-final-form';
import {
  getArrayLength,
  getCheckedValuesInObject,
  getHasElementsInArray,
} from 'utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

import './UnstarSelectAll.styles.scss';

type UnstarSelectAllProps = {
  className?: string;
  nodes?: DataRoomNode[];
};

type FormValues = {
  nodeIds?: Record<string, boolean>;
};

const UnstarSelectAll: React.FC<UnstarSelectAllProps> = (props) => {
  const { className, nodes } = props;

  const classes = classNames('unstar-select-all', className);

  const { t } = useTranslation();
  const { change } = useForm();
  const {
    values: { nodeIds },
  } = useFormState<FormValues>();

  const selectedIds = useMemo(
    () => getCheckedValuesInObject(nodeIds),
    [nodeIds],
  );

  const isAllChecked = useMemo(
    () => getArrayLength(selectedIds) === getArrayLength(nodes),
    [nodes, selectedIds],
  );

  const isAllMixed = useMemo(
    () => !isAllChecked && getHasElementsInArray(selectedIds),
    [isAllChecked, selectedIds],
  );

  const onChangeAll = useCallback(() => {
    const shouldCheckAll = !isAllChecked || isAllMixed;

    const newNodeIds = nodes.reduce(
      (acc, { _id }) => ({
        ...acc,
        [_id]: shouldCheckAll,
      }),
      {},
    );

    change('nodeIds', newNodeIds);
  }, [isAllMixed, isAllChecked, nodes, change]);

  return (
    <div className={classes}>
      <p>{t('starredFiles', { count: nodes.length })}</p>
      <Checkbox
        checked={isAllChecked}
        className={classNames({ mixed: isAllMixed })}
        onChange={onChangeAll}
      />
    </div>
  );
};

export default UnstarSelectAll;
